// tslint:disable
export var TCSMedBenefitCommunicationType;
(function (TCSMedBenefitCommunicationType) {
    // Mail
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Mail"] = 0] = "Mail";
    // Fax
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Fax"] = 1] = "Fax";
    // Voice Mail
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Voicemail"] = 2] = "Voicemail";
    // Phone
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Phone"] = 3] = "Phone";
    // Email
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Email"] = 4] = "Email";
    // Feed
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Feed"] = 5] = "Feed";
    // Void
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Void"] = 6] = "Void";
    // Message Center
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Message"] = 7] = "Message";
    // Patient / Legal Guardian (if under 18)
    TCSMedBenefitCommunicationType[TCSMedBenefitCommunicationType["Guardian"] = 8] = "Guardian";
})(TCSMedBenefitCommunicationType || (TCSMedBenefitCommunicationType = {}));
TCSMedBenefitCommunicationType['MAIL'] = 0;
TCSMedBenefitCommunicationType['FAX'] = 1;
TCSMedBenefitCommunicationType['VOICEMAIL'] = 2;
TCSMedBenefitCommunicationType['PHONE'] = 3;
TCSMedBenefitCommunicationType['EMAIL'] = 4;
TCSMedBenefitCommunicationType['FEED'] = 5;
TCSMedBenefitCommunicationType['VOID'] = 6;
TCSMedBenefitCommunicationType['MESSAGE'] = 7;
TCSMedBenefitCommunicationType['GUARDIAN'] = 8;
//# sourceMappingURL=TCSMedBenefitCommunicationType.js.map